import { MemberStatuses } from "./MemberStatuses";
import { Api } from "../../services/Api";
import { Utility } from "../../utils";

interface MinFullName {
    degrees?: string;
    firstName?: string;
    lastName?: string;
    middleName?: string;
}

export class MemberHelper {
    public static fullName(m: MinFullName, includeDegree: boolean) {
        let name = Utility.joinSkipEmpty([m.firstName, m.middleName, m.lastName], " ");
        if (includeDegree && m.degrees)
            name += ", " + m.degrees;
        return name;
    }

    public static getAmountDue = async (api: Api, userId: number) => {
        return await api.get(Api.endpoints.members.duesAmount.withUrlParams({ userId }));
    }

    public static getStatus = async (api: Api, userId: number) => {
        return await api.get(Api.endpoints.members.status.withUrlParams({ userId }));
    }

    public static checkStatusIsActive = async (api: Api, userId: number) => {
        const result = await MemberHelper.getStatus(api, userId);
        return result.isSuccess && result.data && MemberStatuses.isActive(result.data.memberStatusId || 0);
    }
}



// WEBPACK FOOTER //
// ./src/models/member/MemberHelper.ts